import Tooltip from "@reach/tooltip";
import React from "react";
import { UserMinimalFragment } from "../../../../graphql/fragments";
import useTranslations from "../../../../hooks/useTranslations";
import { AvatarGroup } from "../../../wombat-ui";

type TemplateQuestionTitleProps = {
  displayIndex: string;
  title: string;
  description?: string;
  referents?: UserMinimalFragment[];
};

const TemplateQuestionTitle: React.FC<TemplateQuestionTitleProps> = ({
  title,
  description,
  displayIndex,
  referents = [],
}) => {
  const t = useTranslations();

  if (referents.length > 0)
    return (
      <Tooltip
        label={
          referents.length > 0
            ? t("reports.evaluationAlsoDoneBy", {
                referents: referents.map((r) => r.name).join(", "),
              })
            : t("reports.evaluationByYouAndHR")
        }
      >
        <div className="flex flex-col space-y-2">
          <div className="flex justify-start text-base font-bold gap-x-2 text-secondary-700">
            <div>
              <span className="pr-2 text-base font-bold">{displayIndex}.</span>
              {title}
            </div>
            <AvatarGroup
              items={referents.map((r) => ({
                src: r.avatar,
                alt: `${r.name} profile picture`,
                type: "user",
                "data-test-id": `referent-avatar-${r.id}`,
              }))}
            />
          </div>
          {description && (
            <div className="flex flex-col space-y-1 text-sm text-light-900">
              <span>{t("reports.questionDescription")}</span>
              <span>{description}</span>
            </div>
          )}
        </div>
      </Tooltip>
    );
  return (
    <div className="flex flex-col space-y-2">
      <div className="flex justify-between text-base font-bold text-secondary-700">
        <div>
          <span className="pr-2 text-base font-bold">{displayIndex}.</span>
          {title}
        </div>
      </div>
      {description && (
        <div className="flex text-sm text-light-900">{description}</div>
      )}
    </div>
  );
};

export default React.memo(TemplateQuestionTitle);
